module.exports = __webpack_public_path__ + "static/digital_small-da23ae873fc6fc2a7117592eed9ed32d.jpg";